<div [matMenuTriggerFor]="menu" class="user-profile-wrapper">
    @if (userDetails) {
    <div class="user-details">
        <srp-icon icon="account_circle"></srp-icon>
        <div class="srp-profile-name">
            <span class="user_about1">{{userDetails.userName}}{{userNickname ? `(${userNickname})` : ''}}</span>
            <span class="user_about2">{{`${userDetails.userRrdiCode}`}}</span>
        </div>
        <srp-icon icon="arrow_drop_down"></srp-icon>
    </div>
    }

</div>

<mat-menu class="userMatMenu srp-user-profile-model" #menu="matMenu">
    <div class="user_info" mat-menu-item (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
        <srp-icon class="user_profile_icon2" icon="account_circle"></srp-icon>
        <span class="user_about_name">{{userDetails.firstName}}</span>
        <span class="user_about_role">{{userDetails.roleName}}</span>
        <span class="user_about_email">{{userDetails.email}}</span>
    </div>
    <div class="srp-user-profile-options">
        @for(menu of adminLinks; track menu) {
            <div class="user_profile_option">
                <a mat-menu-item (click)="navigate(menu)" (keydown.enter)="navigate(menu)">{{menu.label}}</a>
            </div>
        }
        @if (!isFromUserMenu) {
            <div class="user_profile_option">
                <a mat-menu-item (click)="externalLinkNavigation(poiLink)" (keydown.enter)="externalLinkNavigation(poiLink)">{{(labels | contentFilter: LABELS.POI_LINK) || 'POI Link'}}</a>
            </div>
            <div class="user_profile_option">
                <a mat-menu-item (click)="externalLinkNavigation(tiLink)" (keydown.enter)="externalLinkNavigation(tiLink)">{{(labels | contentFilter: LABELS.TI_LINK) || 'TI Link'}}</a>
            </div>
        }
        <div class="user_profile_option">
            <a (click)="logout()" (keydown.enter)="logout()" mat-menu-item>{{(labels | contentFilter: LABELS.LOGOUT) || 'Logout'}}</a>
        </div>
    </div>

</mat-menu>